import SpaceDashboard from "@mui/icons-material/SpaceDashboard";
import Camera from "@mui/icons-material/Camera";
import InsertInvitation from "@mui/icons-material/InsertInvitation";
import TocRounded from "@mui/icons-material/TocRounded";
import Insights from "@mui/icons-material/Insights";
import PersonSearchRounded from "@mui/icons-material/PersonSearchRounded";
import FavoriteRounded from "@mui/icons-material/FavoriteRounded";
// import SettingsRounded from "@mui/icons-material/SettingsRounded";
// import BubbleChart from "@mui/icons-material/BubbleChart";

const Menuitems = [
  {
    id: "hub",
    title: "",
    ariaLabel: "Dashboard",
    icon: SpaceDashboard,
    href: "/",
    sx: { fontSize: "1.8rem", transform: "rotate(-90deg)" },
    prefetch: false,
  },
  {
    id: "video",
    title: "",
    ariaLabel: "Video",
    icon: Camera,
    href: "/video",
    sx: { fontSize: "2rem" },
    prefetch: false,
    isVideoLink: true,
  },
  {
    id: "calendar",
    title: "",
    ariaLabel: "Calendar",
    icon: InsertInvitation,
    href: "/calendar",
    sx: { fontSize: "1.9rem" },
    prefetch: false,
  },
  {
    id: "meetings",
    title: "",
    ariaLabel: "Meetings",
    icon: TocRounded,
    href: "/meetings",
    sx: { fontSize: "2rem", transform: "rotate(180deg)" },
    prefetch: false,
  },
  {
    id: "Performance",
    title: "",
    ariaLabel: "Performance",
    icon: Insights,
    href: "/stats",
    sx: { fontSize: "1.7rem" },
    prefetch: false,
  },
  {
    id: "search",
    title: "",
    ariaLabel: "Search",
    icon: PersonSearchRounded,
    href: "/search",
    sx: { fontSize: "2.1rem" },
    prefetch: false,
  },
  {
    id: "saved",
    title: "",
    ariaLabel: "Saved Profile",
    icon: FavoriteRounded,
    href: "/saved",
    sx: { fontSize: "1.8rem" },
    prefetch: false,
  },
  // {
  //   id: "settings",
  //   title: "",
  //   ariaLabel: "Settings",
  //   icon: SettingsRounded,
  //   href: "/settings",
  //   sx: { fontSize: "1.9rem" },
  //   prefetch: false,
  // },
  // {
  //   id: "support",
  //   title: "",
  //   ariaLabel: "Help Center",
  //   icon: BubbleChart,
  //   href: "/support",
  //   sx: { fontSize: "2rem" },
  //   prefetch: false,
  // },
];

export default Menuitems;
